import React, { Component } from 'react';
import styled from 'styled-components';
import { Collapse } from 'react-collapse';
import SingleDish from './SingleDish';
import ArrowBackIcon from '../../../images/arrow-black.png';

export default class SingleMeal extends Component {
  state = {
    isOpened: false,
  };

  open = () => {
    const { isOpened } = this.state;
    this.setState({ isOpened: !isOpened });
  };

  renderMeals = () => {
    const { meal } = this.props;
    return meal.map((dish) => <SingleDish key={dish.id} meal={dish} />);
  };

  render() {
    const { name } = this.props;
    const { isOpened } = this.state;
    return (
      <SingleMealItem>
        <Name onClick={this.open} isOpened={isOpened}>
          <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpened} />
          {name}
        </Name>
        <Collapse isOpened={isOpened}>
          <Dishes>{this.renderMeals()}</Dishes>
        </Collapse>
      </SingleMealItem>
    );
  }
}

const SingleMealItem = styled.div`
  width: 100%;
`;

const Name = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
  padding-left: 80px;
  cursor: pointer;
  font-size: 16px;
  box-sizing: border-box;
  border-top: 1px solid #c1c1c1;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background: ${(props) => (props.isOpened ? '#c1c1c1' : 'fff')};
  &:hover {
    background: #c1c1c1;
  }
  @media (max-width: 768px) {
    padding-left: 45px;
  }
`;

const ImgArrow = styled.img`
  position: absolute;
  left: 50px;
  bottom: 10px;
  width: 20px;
  height: 20px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
  @media (max-width: 768px) {
    left: 15px;
  }
`;

const Dishes = styled.div`
  width: 100%;
  border-top: 1px solid #c1c1c1;
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/SingleMeal.jsx